import React from 'react'
import { createMarkup } from '../../utils/helpers'

import styles from './Item.module.scss'

export type ItemProps = {
  id: Number
  title: string
  detail: string
  hasBorder: boolean
}

const Item = ({ ...props }: ItemProps) => {
  return (
    <div className={`${styles.item} ${props.hasBorder && styles.hasBorder}`}>
      <div className={styles.num}>{String(props.id).padStart(2, '0')}</div>
      <h3
        className={styles.title}
        dangerouslySetInnerHTML={createMarkup(props.title, true)}
      ></h3>
      <div
        className={styles.detail}
        dangerouslySetInnerHTML={createMarkup(props.detail)}
      ></div>
    </div>
  )
}

export default Item
